module.exports = __webpack_public_path__ + "static/img/xfqxaqs.b8740a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xfqxaqs.jpg
// module id = tvdB
// module chunks = 21